<template>
  <div>
    <ItemListFilters />

    <v-card outlined>
      <v-data-table
        :items="items"
        :headers="headers"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        :no-data-text="$t('table.noResults')"
        :loading-text="$t('table.loading')"
        @dblclick:row="showItemRow"
        mobile-breakpoint="20"
        class="clickable"
        hide-default-footer
        disable-sort
      >
        <template v-slot:[`item.date_created`]="{ item }">
          {{ item.date_created ? formatDate(item.date_created) : '---' }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex justify-end">
            <v-btn @click="showItem(item.id)" class="mx-2" icon small>
              <v-icon small> mdi-eye </v-icon>
            </v-btn>
            <v-btn
              @click="handleOpenCreateEditItemModal(item.id)"
              class="mx-2"
              icon
              small
            >
              <v-icon small> mdi-pencil </v-icon>
            </v-btn>
            <v-btn
              @click="handleDeleteItemModal(item.id)"
              class="mx-2"
              icon
              small
            >
              <v-icon small> mdi-delete </v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <h-pagination :fetch="fetchItems" />

    <RightDrawer :moreInfo="false">
      <ItemDetails />
    </RightDrawer>

    <ItemDelete />
    <ItemCreateEdit
      :isAnUpdate="false"
      :isOnlyForCreateAnItem="true"
      ref="createItem"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { itemHeaders } from '@/views/item/listHeaders'
import { catalogDate } from '@/util/catalog'

import RightDrawer from '@/components/app/RightDrawer'
import ItemDelete from '@/views/item/components/ItemDelete'
import ItemDetails from '@/views/item/components/ItemDetails'
import ItemCreateEdit from '@/views/item/components/ItemCreateEdit'
import ItemListFilters from '@/views/item/components/ItemListFilters'

export default {
  name: 'ItemList',

  components: {
    ItemDelete,
    RightDrawer,
    ItemDetails,
    ItemCreateEdit,
    ItemListFilters,
  },

  data() {
    return {
      headers: itemHeaders,
      formatDate: catalogDate,
    }
  },

  computed: {
    ...mapGetters(['items', 'isLoading', 'itemsPerPage']),
  },

  methods: {
    ...mapMutations(['setIsDrawerOpen']),
    ...mapActions([
      'fetchItem',
      'fetchItems',
      'handleDeleteItemModal',
      'handleOpenCreateEditItemModal',
    ]),

    showItem(itemId) {
      this.setIsDrawerOpen(true)
      this.fetchItem(itemId)
    },

    createItem() {
      this.handleOpenCreateEditItemModal()
      this.$nextTick(() => this.$refs.createItem.resetItemFields())
    },

    showItemRow(_, { item }) {
      this.showItem(item?.id)
    },
  },

  mounted() {
    this.fetchItems()
  },
}
</script>
